import styled from 'styled-components';

import { UiButton } from '@/components/ui/Button';
import { UiTypography } from '@/components/ui/Typography';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const PageStyles = styled(OnboardingPage)`
  ion-content {
    --background: url(https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/layout-own-ai-ons/welcome/bg.png)
      center/cover no-repeat;

    &::part(scroll) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      margin-top: 16px;
    }

    .content-wrapper {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 48px 16px 24px;
      display: flex;
      flex-direction: column;
      align-items: center;
      backdrop-filter: blur(3px);
      z-index: 10;
    }

    .app-logo {
      margin-bottom: 20px;
    }
    .page-title {
      margin-bottom: 100px;
    }
  }
`;

export const PageTitleStyles = styled(UiTypography)`
  font-weight: 900;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
  text-transform: uppercase;

  .ion-page & {
    z-index: 10;
  }
`;

export const PageSubtitleStyles = styled(UiTypography)`
  .ion-page & {
    color: transparent;
  }
`;

export const BottomButtonStyles = styled(UiButton)`
  position: fixed;
  bottom: 34px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  max-width: 500px;
  height: 48px;
  padding: 0 16px;
`;

export const OverlayStyles = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5;
  pointer-events: none;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 52.81%,
    rgba(5, 1, 14, 0.84) 70.83%,
    #0a021a 80.49%,
    #1f0650 100%
  );
`;
